<signature-pad [options]="signaturePadOptions"></signature-pad>
<processing-buttons [cancelButtonTitle]="cancelButtonTitle"
                    [continueButtonTitle]="continueButtonTitle"
                    [showCancelButton]="showCancelButton"
                    [showContinueButton]="showContinueButton"
                    (onCancel)="clearPad()"
                    (onContinue)="getSignatureAndFinish()"
></processing-buttons>
